import React, { FC, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { TransformedBanners } from 'app/api/services-strapi/banners/types';

import { Carousel as CarouselComponent } from 'app/design-system/components/Carousel';
import { PreviewLabel } from 'app/design-system/components/PreviewLabel';
import Banner from 'app/widgets/Banner';

import { selectNotFinishedMatchIds } from '../../selectors';
import MatchTile from '../MatchTile';

import styles from './Carousel.module.scss';

// ---

type MatchCarouselProps = {
  banners: TransformedBanners;
};

// TODO: https://github.com/brainhubeu/react-carousel
const Carousel: FC<MatchCarouselProps> = memo(({ banners }) => {
  const matchIds = useSelector(selectNotFinishedMatchIds);

  const filteredBanners = useMemo(() => (
    banners.filter((banner) => (
      typeof banner.matchOfTheDayId === 'number'
        ? matchIds.includes(banner.matchOfTheDayId)
        : true
    ))
  ), [banners]);

  return (
    <CarouselComponent>
      {filteredBanners.map((banner) => {
        return (
          <div key={banner.id}
               className={styles.carouselContainer}>

            {banner.isPreviewMode && <PreviewLabel title="preview" />}

            {typeof banner.matchOfTheDayId === 'number'
              ? (
                <MatchTile image={banner.image}
                           matchId={banner.matchOfTheDayId} />

              ) : (
                <Banner description={banner.description}
                        title={banner.title}
                        image={banner.image}
                        link={banner.link}
                        promoId={banner.promoId}
                        isPromo={banner.isPromo}
                        bannerId={banner.id} />
              )}
          </div>
        );
      })}
    </CarouselComponent>
  );
});

export default Carousel;
